<template lang="pug">
  .container-reg-2
    el-steps(align-center).reg-steps
      el-step(title="填写账号密码", status="success")
      el-step(title="完善商家资料", status="finish")
      el-step(title="绑定联系方式")
    c-header-small
      template(slot="left")
        h3 完善商家资料
    el-form(:model="source", label-width="200px", v-loading="loading").reg-form
      template(v-if="source.type === 1")
        h4 基本信息
        el-row(:gutter="10")
          el-col(:span="12")
            el-form-item(label="商家类型")
              el-radio(v-model.trim="source.type", :label="1") 公司
              el-radio(v-model.trim="source.type", :label="2") 个人
            el-form-item(label="公司名称", required)
              el-input(v-model.trim="source.mch_name")
            template(v-if="source.opt == 1") 
              el-form-item(label="统一社会信用代码或注册号", required)
                el-input(v-model.trim="source.uni_credit")
            template(v-else)
              el-form-item(label="营业执照号", required)
                el-input(v-model.trim="source.business_license")
              el-form-item(label="组织机构代码", required)
                el-input(v-model.trim="source.organization_code")
              el-form-item(label="税务登记证件号", required)
                el-input(v-model.trim="source.tax_registration_no")
          el-col(:span="12")
            el-form-item(label="") &nbsp; 
            el-form-item(label="营业执照类型", required)
              el-select(v-model.trim="source.opt")
                el-option(:value="1", label="三证合一，一证一码")
                el-option(:value="2", label="一证三号或三证独立")
            el-form-item(label="营业执照照片", required)
              el-upload(ref="upload", :action="uploadURL", :auto-upload="false", accept="image/*",
                :show-file-list="false", :on-change="(file) => uploadChange(file, 'business_license_pic_preview', 'business_license_pic')")
                el-button(type="primary") 选择文件
            el-form-item(label="")
              img(v-if="source.business_license_pic", :src="source.business_license_pic | image", 
                @click="$zoom($options.filters.image(source.business_license_pic))").mch-image
              img(v-else-if="source.business_license_pic_preview", :src="source.business_license_pic_preview",
                @click="$zoom(source.business_license_pic_preview)").mch-image
              template(v-else) 未上传
        hr
        h4 法人信息
        el-row(:gutter="10")
          el-col(:span="12")
            el-form-item(label="法人姓名", required)
              el-input(v-model.trim="source.legal_per_name")
            el-form-item(label="法人证件号码",required)
              el-input(v-model.trim="source.legal_per_id_no")
            el-form-item(label="法人手机号",required)
              el-input(v-model.trim="source.legal_per_telephone_no")
          el-col(:span="12")
            el-form-item(label="法人证件类型",required)
              el-select(v-model.trim="source.legal_per_id_type")
                el-option(value="01", label="身份证")
            el-form-item(label="法人身份证",required)
              el-row
                el-col(:span="12")
                  el-upload(ref="upload", :action="uploadURL", :auto-upload="false", accept="image/*",
                    :show-file-list="false", :on-change="(file) => uploadChange(file, 'legal_per_id_positive_preview', 'legal_per_id_positive')")
                    el-button(type="primary") 姓名面
                el-col(:span="12")
                  el-upload(ref="upload", :action="uploadURL", :auto-upload="false", accept="image/*",
                    :show-file-list="false", :on-change="(file) => uploadChange(file, 'legal_per_id_opposite_preview', 'legal_per_id_opposite')")
                    el-button(type="primary") 国徽面
            el-form-item(label="")
              el-row
                el-col(:span="12")
                  img(v-if="source.legal_per_id_positive", :src="source.legal_per_id_positive | image", 
                    @click="$zoom($options.filters.image(source.legal_per_id_positive))").mch-image
                  img(v-else-if="source.legal_per_id_positive_preview", :src="source.legal_per_id_positive_preview",
                    @click="$zoom(source.legal_per_id_positive_preview)").mch-image
                  template(v-else) 未上传
                el-col(:span="12")
                  img(v-if="source.legal_per_id_opposite", :src="source.legal_per_id_opposite | image", 
                    @click="$zoom($options.filters.image(source.legal_per_id_opposite))").mch-image
                  img(v-else-if="source.legal_per_id_opposite_preview", :src="source.legal_per_id_opposite_preview",
                    @click="$zoom(source.legal_per_id_opposite_preview)").mch-image
                  template(v-else) 未上传
        hr
        h4 责任人信息
        el-row(:gutter="10")
          el-col(:span="12")
            el-form-item(label="责任人姓名", required)
              el-input(v-model.trim="source.resp_per_name")
            el-form-item(label="责任人证件号码", required)
              el-input(v-model.trim="source.resp_per_id_no")
          el-col(:span="12")
            el-form-item(label="责任人证件类型",required)
              el-select(v-model.trim="source.resp_per_id_type")
                el-option(value="01", label="身份证")
        hr
        h4 公司联系方式
        el-row(:gutter="10")
          el-col(:span="12")
            el-form-item(label="商户电话")
              el-input(v-model.trim="source.tel")
          el-col(:span="12")
            el-form-item(label="公司地址")
              el-input(v-model.trim="source.business_address")
        hr
        h4 钱包提现账号
        el-row(:gutter="10")
          el-col(:span="12")
            el-form-item(label="开户名",required)
              el-input(v-model.trim="source.public_account_name",disabled)
            el-form-item(label="开户银行所在地",required)
              el-select(v-model.trim="source.bankArea", @change="getBankList()", clearable, filterable,value-key="area_code")
                el-option(v-for="b in bankAreaList", :key="b.area_code", :value="b", :label="b.province_name + b.city_name")
            el-form-item(label="对公账户账号",required)
              el-input(v-model.trim="source.public_account")
          el-col(:span="12")
            el-form-item(label="开户银行",required)
              el-select(v-model.trim="source.bankClass", @change="getBankAreaList()", clearable, filterable,value-key="class_code")
                el-option(v-for="b in bankClassList", :key="b.class_code", :value="b", :label="b.class_name")
            el-form-item(label="支行名称",required)
              el-select(v-model.trim="source.bank", clearable, filterable, value-key="bank_code", @change="getBank()" )
                el-option(v-for="b in bankList", :key="b.bank_code", :value="b", :label="b.bank_name")
            el-form-item(label="对公账户证明",required)
              el-upload(ref="upload", :action="uploadURL", :auto-upload="false", accept="image/*",
                :show-file-list="false", :on-change="(file) => uploadChange(file, 'public_account_pic_preview', 'public_account_pic')")
                el-button(type="primary") 选择文件
            el-form-item(label="")
              img(v-if="source.public_account_pic", :src="source.public_account_pic | image", 
                @click="$zoom($options.filters.image(source.public_account_pic))").mch-image
              img(v-else-if="source.public_account_pic_preview", :src="source.public_account_pic_preview",
                @click="$zoom(source.public_account_pic_preview)").mch-image
              template(v-else) 未上传    
      template(v-if="source.type === 2")
        h4 基本信息
        el-row(:gutter="10")
          el-col(:span="12")
            el-form-item(label="商家类型")
              el-radio(v-model.trim="source.type", :label="1") 公司
              el-radio(v-model.trim="source.type", :label="2") 个人
            el-form-item(label="姓名", required)
              el-input(v-model.trim="source.resp_per_name")
            el-form-item(label="证件号", required)
              el-input(v-model.trim="source.resp_per_id_no")
          el-col(:span="12")
            el-form-item(label="") &nbsp;
            el-form-item(label="证件类型", required)
              el-select(v-model.trim="source.resp_per_id_type")
                el-option(value="01", label="身份证")
            el-form-item(label="联系地址")
              el-input(v-model.trim="source.business_address")
        h4 补充资料
        el-row(:gutter="10")     
          el-col(:span="12")
            el-form-item(label="营业执照")
              el-upload(ref="upload", :action="uploadURL", :auto-upload="false", accept="image/*",
                :show-file-list="false", :on-change="(file) => uploadChange(file, 'business_license_pic_preview', 'business_license_pic')")
                el-button(type="primary") 选择文件
            el-form-item(label="")
              img(v-if="source.business_license_pic", :src="source.business_license_pic | image", 
                @click="$zoom($options.filters.image(source.business_license_pic))").mch-image
              img(v-else-if="source.business_license_pic_preview", :src="source.business_license_pic_preview",
                @click="$zoom(source.business_license_pic_preview)").mch-image
              template(v-else) 未提交
          el-col(:span="12")
            el-form-item(label="身份证件照片")
              el-row
                el-col(:span="11")
                  el-upload(ref="upload", :action="uploadURL", :auto-upload="false", accept="image/*", :show-file-list="false", :on-change="(file) => uploadChange(file, 'resp_per_id_positive_preview', 'resp_per_id_positive')")
                    el-button(type="primary") 上传身份证正面
                  img(v-if="source.resp_per_id_positive", :src="source.resp_per_id_positive | image",
                    @click="$zoom($options.filters.image(source.resp_per_id_positive))").mch-image
                  img(v-else-if="source.resp_per_id_positive_preview", :src="source.resp_per_id_positive_preview",
                    @click="$zoom(source.resp_per_id_positive_preview)").mch-image
                  template(v-else) 未提交
                el-col(:span="11", :offset="2")
                  el-upload(ref="upload", :action="uploadURL", :auto-upload="false", accept="image/*", :show-file-list="false", :on-change="(file) => uploadChange(file, 'resp_per_id_opposite_preview', 'resp_per_id_opposite')")
                    el-button(type="primary") 上传身份证反面
                  img(v-if="source.resp_per_id_opposite", :src="source.resp_per_id_opposite | image",@click="$zoom($options.filters.image(source.resp_per_id_opposite))").mch-image
                  img(v-else-if="source.resp_per_id_opposite_preview", :src="source.resp_per_id_opposite_preview",@click="$zoom(source.resp_per_id_opposite_preview)").mch-image
                  template(v-else) 未提交

      .align-center.txt-tip-warn 请根据签约的业务及合同要求，完善商家资料信息，否则将审核不通过。
      .reg-form-button-group(v-loading="loading", :element-loading-fullscreen="false")
        el-button(type="primary", @click="save", :disabled="loading").reg-button 下一步
        el-button(type="primary", @click="draftSave", :disabled="loading").reg-button 保存草稿
        
</template>

<script>
import { errorDictionaries } from "@/gadgets/dictionaries";
// import getDataTree from '../gadgets/dataTree';
export default {
  data() {
    return {
      source: {
        type: 1,
        mch_name: null,
        business_license: null,
        legal_per_name: null,
        resp_per_id_type: "01",
        resp_per_id_no: null,
        resp_per_name: null,
        resp_per_telephone_no: null,
        resp_per_email: null,
        tel: null,
        business_address: null,
        settle_type: 1,
        deposit_bank: null,
        deposit_bank_province: null,
        deposit_bank_city: null,
        business_license_pic: null,
        business_license_pic_preview: null,
        resp_per_id_positive: null,
        resp_per_id_positive_preview: null,
        resp_per_id_opposite: null,
        resp_per_id_opposite_preview: null,
        legal_per_id_no: null,
        legal_per_id_type: "01",
        organization_code: null,
        public_account: null,
        public_account_name: null,
        public_account_pic: null,
        sub_branch_bank: null,
        tax_registration_no: null,
        union_bank: null,
        legal_per_id_opposite: null,
        legal_per_id_positive: null,
        legal_per_telephone_no: null,
        uni_credit: null,
        class_code: "",
        area_code: "",
        bankArea: {},
        bankClass: {},
        bank: {},
        deposit_bank_id: null,
        area_id: null,
        opt: 1,
      },
      loading: false,
      uploadURL: "/mch_web/v1/upload_picture",
      bankClassList: [],
      bankAreaList: [],
      bankList: [],
    };
  },
  watch: {
    "source.mch_name"(newVal, oldVal) {
      this.source.public_account_name = newVal;
    },
  },
  methods: {
    next() {
      this.$router.replace("/reg/3");
    },
    uploadChange(file, previewKey, urlKey) {
      const { name, size } = file;
      if (size < 0.5 * 1024 * 1024) {
        const fr = new FileReader();
        fr.onload = (e) => {
          this.loading = true;
          const result = e.target.result;
          this.$set(this.source, previewKey, result);
          const pic_data = result.split(",")[1];

          //获取尾缀名
          const beginIdx = name.lastIndexOf(".");
          const endIdx = name.length;
          const ext = name.substring(beginIdx + 1, endIdx);
          const params = {
            pic_data,
            ext,
          };
          this.$store
            .dispatch("UPLOAD", params)
            .then(({ url }) => {
              this.$set(this.source, urlKey, url);
            })
            .catch(({ code, msg }) => {
              this.$alert(`商家资料图片上传失败。${code}：${msg}`, {
                type: "error",
              });
            })
            .finally(() => {
              this.loading = false;
            });
        };
        fr.readAsDataURL(file.raw);
      } else {
        this.$alert("图片上传失败。文件大小超过500KB。", {
          type: "error",
        });
      }
    },

    validate() {
      const type = this.source.type;
      if (type === 1) {
        if (!this.source.mch_name) {
          this.$message({
            type: "warning",
            message: `请输入公司名称`,
          });
          return false;
        } else if (!this.source.uni_credit && this.source.opt == 1) {
          this.$message({
            type: "warning",
            message: `请输入统一社会信用代码或注册号`,
          });
          return false;
        } else if (!this.source.business_license && this.source.opt == 2) {
          this.$message({
            type: "warning",
            message: `请输入营业执照号`,
          });
          return false;
        } else if (!this.source.organization_code && this.source.opt == 2) {
          this.$message({
            type: "warning",
            message: `请输入组织机构代码`,
          });
          return false;
        } else if (!this.source.tax_registration_no && this.source.opt == 2) {
          this.$message({
            type: "warning",
            message: `请输入税务登记证件号`,
          });
          return false;
        } else if (!this.source.business_license_pic) {
          this.$message({
            type: "warning",
            message: `请上传营业执照`,
          });
          return false;
        } else if (!this.source.legal_per_name) {
          this.$message({
            type: "warning",
            message: `请输入法人姓名`,
          });
          return false;
        } else if (!this.source.legal_per_telephone_no) {
          this.$message({
            type: "warning",
            message: `请输入法人手机号`,
          });
          return false;
        } else if (!this.source.resp_per_name) {
          this.$message({
            type: "warning",
            message: `请输入责任人姓名`,
          });
          return false;
        } else if (!this.source.legal_per_id_no) {
          this.$message({
            type: "warning",
            message: `请输入法人证件号码`,
          });
          return false;
        } else if (!this.source.public_account_name) {
          this.$message({
            type: "warning",
            message: `请输入开户名`,
          });
          return false;
        } else if (!this.source.deposit_bank_province) {
          this.$message({
            type: "warning",
            message: `请选择开户银行所在地`,
          });
          return false;
        } else if (!this.source.public_account) {
          this.$message({
            type: "warning",
            message: `请输入对公账户账号`,
          });
          return false;
        } else if (!this.source.deposit_bank) {
          this.$message({
            type: "warning",
            message: `请选择开户银行`,
          });
          return false;
        } else if (!this.source.union_bank) {
          this.$message({
            type: "warning",
            message: `请输入选择支行名称`,
          });
          return false;
        } else if (!this.source.legal_per_id_positive) {
          this.$message({
            type: "warning",
            message: `请上传法人身份证正面`,
          });
          return false;
        } else if (!this.source.legal_per_id_opposite) {
          this.$message({
            type: "warning",
            message: `请上传法人身份证反面`,
          });
          return false;
        } else if (!this.source.public_account_pic) {
          this.$message({
            type: "warning",
            message: `请上传对公账户证明`,
          });
          return false;
        }
      } else if (type === 2) {
        if (!this.source.resp_per_name) {
          this.$message({
            type: "warning",
            message: "请输入个人姓名",
          });
          return false;
        }
      }

      if (!this.source.resp_per_id_no) {
        const message = type === 1 ? "请输入责任人证件号" : "请输入证件号码";
        this.$message({
          type: "warning",
          message,
        });
        return false;
      }
      return true;
    },
    // 完善商家或者个人
    save() {
      if (this.validate()) {
        this.loading = true;
        const action =
          this.source.type === 1 ? "FILL_COMPANY_DETAIL" : "FILL_PERSON_DETAIL";
        let params = Object.assign({}, this.source, {
          mch_name:
            this.source.type === 1
              ? this.source.mch_name
              : `${this.source.resp_per_name}-${+new Date()}`,
        });

        delete params.business_license_pic_preview;
        delete params.resp_per_id_positive_preview;
        delete params.resp_per_id_opposite_preview;
        delete params.legal_per_id_positive_preview;
        delete params.legal_per_id_opposite_preview;
        delete params.public_account_pic_preview;
        if (params.opt !== 1) {
          delete params.uni_credit;
        }
        if (params.opt !== 2) {
          delete params.business_license;
          delete params.organization_code;
          delete params.tax_registration_no;
        }

        let obj = {
          area_id: this.source.area_id,
          deposit_bank: this.source.deposit_bank,
          deposit_bank_city: this.source.deposit_bank_city,
          deposit_bank_id: this.source.deposit_bank_id,
          deposit_bank_province: this.source.deposit_bank_province,
          public_account: this.source.public_account,
          public_account_name: this.source.public_account_name,
          public_account_pic: this.source.public_account_pic,
          sub_branch_bank: this.source.sub_branch_bank,
          union_bank: this.source.union_bank,
        };
        params.mch_public_list = JSON.stringify([obj]);

        this.$store
          .dispatch(action, params)
          .then(() => {
            this.next();
          })
          .catch(({ code, msg }) => {
            this.draftSave();
            if (code === 1004) {
              const start = msg.indexOf("：");
              const key = msg.substring(start + 1);
              const errorMsg = errorDictionaries[key];
              this.$message({
                type: "error",
                message: `${errorMsg}输入有误，请检查后，重新输入`,
              });
            } else {
              this.$message({
                type: "error",
                message: `${msg}`,
              });
            }
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    // 存商家或者个人草稿
    draftSave() {
      this.loading = true;
      const action =
        this.source.type === 1 ? "FILL_MCH_DRAFT_INFO" : "FILL_PERSON_DRAFT_INFO";
      const params = Object.assign({}, this.source, {
        mch_name:
          this.source.type === 1
            ? this.source.mch_name
            : `${this.source.resp_per_name}-${+new Date()}`,
      });

      delete params.business_license_pic_preview;
      delete params.resp_per_id_positive_preview;
      delete params.resp_per_id_opposite_preview;
      delete params.legal_per_id_positive_preview;
      delete params.legal_per_id_opposite_preview;
      delete params.public_account_pic_preview;

      console.log(this.source);
      let obj = {
        area_id: this.source.area_id || "",
        deposit_bank: this.source.deposit_bank || "",
        deposit_bank_city: this.source.deposit_bank_city || "",
        deposit_bank_id: this.source.deposit_bank_id || "",
        deposit_bank_province: this.source.deposit_bank_province || "",
        public_account: this.source.public_account || "",
        public_account_name: this.source.public_account_name || "",
        public_account_pic: this.source.public_account_pic || "",
        sub_branch_bank: this.source.sub_branch_bank || "",
        union_bank: this.source.union_bank || "",
      };
      params.mch_public_list = JSON.stringify([obj]);
      this.$store
        .dispatch(action, params)
        .then(() => {
          //   this.next();
          this.$message({
            type: "success",
            message: `存入草稿成功`,
          });
        })
        .catch(({ code, msg }) => {
          if (code === 1004) {
            const start = msg.indexOf("：");
            const key = msg.substring(start + 1);
            const errorMsg = errorDictionaries[key];
            this.$message({
              type: "error",
              message: `${errorMsg}输入有误，请检查后，重新输入`,
            });
          } else {
            this.$message({
              type: "error",
              message: `${msg}`,
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // 获取开户银行
    getBankClassList() {
      this.$store
        .dispatch("GET_BANK_CLASS_LIST")
        .then((data) => {
          this.bankClassList = data;
        })
        .catch(({ code, msg }) => {
          this.$message({
            type: "error",
            message: `获取银行列表失败。${code}：${msg}`,
          });
        });
    },

    // 获取开户银行区域
    getBankAreaList() {
      return new Promise((resolve, reject) => {
        if (this.source.bankClass.class_code) {
          this.source.deposit_bank = this.source.bankClass.class_name;
          this.source.deposit_bank_id = this.source.bankClass.class_code;
          this.$store
            .dispatch("GET_BANK_AREA_LIST", this.source.bankClass.class_code)
            .then((data) => {
              this.bankAreaList = data;
              this.source.bankArea = {};
              this.source.bank = {};
              resolve();
            })
            .catch(({ code, msg }) => {
              this.$message({
                type: "error",
                message: `获取银行地区列表失败。${code}：${msg}`,
              });
              resolve();
            });
        } else {
          this.source.bankArea = {};
          this.source.bank = {};
          this.source.area_id = null;
          this.source.deposit_bank_id = null;
          this.source.deposit_bank = null;
          this.source.deposit_bank_city = null;
          this.source.sub_branch_bank = null;
          this.source.union_bank = null;
          resolve();
        }
      });
    },

    // 获取支行
    getBankList() {
      return new Promise((resolve, reject) => {
        if (this.source.bankClass.class_code && this.source.bankArea) {
          this.source.bankArea = this.source.bankArea;
          this.source.deposit_bank_province = this.source.bankArea.province_name;
          this.source.deposit_bank_city = this.source.bankArea.city_name;
          this.source.area_id = this.source.bankArea.area_code;
          const params = {
            class_code: this.source.bankClass.class_code,
            area_code: this.source.bankArea.area_code,
          };
          this.$store
            .dispatch("GET_BANK_LIST", params)
            .then((data) => {
              this.bankList = data;
              this.source.bank = {};
              resolve();
            })
            .catch(({ code, msg }) => {
              this.$message({
                type: "error",
                message: `获取支行列表失败。${code}：${msg}`,
              });
              resolve();
            });
        } else {
          this.source.bank = {};
          this.source.deposit_bank = null;
          this.source.deposit_bank_city = null;
          this.source.sub_branch_bank = null;
          this.source.union_bank = null;
          resolve();
        }
      });
    },

    // 获取最后的支行
    getBank() {
      if (this.source.bank) {
        this.source.sub_branch_bank = this.source.bank.bank_name;
        this.source.union_bank = this.source.bank.bank_code;
      } else {
        this.source.sub_branch_bank = null;
        this.source.union_bank = null;
      }
    },
    // // 获取开户银行区域
    // getBankAreaList() {
    //   if (this.source.bankClass) {
    //     this.source.deposit_bank = this.source.bankClass.class_name;
    //     this.source.deposit_bank_id = this.source.bankClass.class_code;
    //     this.$store
    //       .dispatch("GET_BANK_AREA_LIST", this.source.bankClass.class_code)
    //       .then(data => {
    //         this.bankAreaList = data;
    //         this.source.bankArea = {};
    //         this.source.bank = {};
    //       })
    //       .catch(({ code, msg }) => {
    //         this.$message({
    //           type: "error",
    //           message: `获取银行地区列表失败。${code}：${msg}`
    //         });
    //       });
    //   } else {
    //     this.source.bankArea = {};
    //     this.source.bank = {};
    //     this.source.area_id = null;
    //     this.source.deposit_bank_id = null;
    //     this.source.deposit_bank = null;
    //     this.source.deposit_bank_city = null;
    //     this.source.sub_branch_bank = null;
    //     this.source.union_bank = null;
    //   }
    // },

    // // 获取支行
    // getBankList() {
    //   if (this.source.bankClass && this.source.bankArea) {
    //     this.source.bankArea = this.source.bankArea;
    //     this.source.deposit_bank_province = this.source.bankArea.province_name;
    //     this.source.deposit_bank_city = this.source.bankArea.city_name;
    //     this.source.area_id = this.source.bankArea.area_code;
    //     const params = {
    //       class_code: this.source.bankClass.class_code,
    //       area_code: this.source.bankArea.area_code
    //     };
    //     this.$store
    //       .dispatch("GET_BANK_LIST", params)
    //       .then(data => {
    //         this.bankList = data;
    //         this.source.bank = {};
    //       })
    //       .catch(({ code, msg }) => {
    //         this.$message({
    //           type: "error",
    //           message: `获取支行列表失败。${code}：${msg}`
    //         });
    //       });
    //   } else {
    //     this.source.bank = {};
    //     this.source.deposit_bank = null;
    //     this.source.deposit_bank_city = null;
    //     this.source.sub_branch_bank = null;
    //     this.source.union_bank = null;
    //   }
    // },

    // // 获取最后的支行
    // getBank() {
    //   if (this.source.bank) {
    //     this.source.sub_branch_bank = this.source.bank.bank_name;
    //     this.source.union_bank = this.source.bank.bank_code;
    //   } else {
    //     this.source.sub_branch_bank = null;
    //     this.source.union_bank = null;
    //   }
    // },

    // 获取草稿件
    getDraft() {
      this.$store
        .dispatch("MCH_DRAFT_DETAIL")
        .then(async (data) => {
          let obj = {};
          if (data) {
            obj = JSON.parse(data);
          }
          //   console.log(obj);
          this.source = Object.assign(this.source, obj);
          if (this.source.mch_public_list) {
            this.source.mch_public_list = JSON.parse(this.source.mch_public_list);
          }

          //   console.log(this.source.type);
          // 组合开户银行 所在地 支行名
          // 组合开户银行 所在地 支行名
          console.log("草稿数据", this.source);
          // 只有企业类型的时候，才需要对公相关的银行信息
          if (this.source.type == 1) {
            this.source.bankClass = {
              class_code:
                this.source.mch_public_list.length > 0
                  ? this.source.mch_public_list[0].deposit_bank_id
                  : "",
              class_name:
                this.source.mch_public_list.length > 0
                  ? this.source.mch_public_list[0].deposit_bank
                  : "",
            };
            console.log(1, this.source.bankClass);
            await this.getBankAreaList();
            // this.source.bankArea = {
            //   area_code:
            //     this.source.mch_public_draft_list.length > 0
            //       ? this.source.mch_public_draft_list[0].area_id
            //       : "",
            //   city_name:
            //     this.source.mch_public_draft_list.length > 0
            //       ? this.source.mch_public_draft_list[0].deposit_bank_province
            //       : "",
            //   province_name:
            //     this.source.mch_public_draft_list.length > 0
            //       ? this.source.mch_public_draft_list[0].deposit_bank_city
            //       : ""
            // };
            this.source.bankArea = {
              area_code:
                this.source.mch_public_list.length > 0
                  ? this.source.mch_public_list[0].area_id
                  : "",
              city_name:
                this.source.mch_public_list.length > 0
                  ? this.source.mch_public_list[0].deposit_bank_city
                  : "",
              province_name:
                this.source.mch_public_list.length > 0
                  ? this.source.mch_public_list[0].deposit_bank_province
                  : "",
            };
            console.log(this.source.bankArea);
            await this.getBankList();
            this.source.bank = {
              bank_code:
                this.source.mch_public_list.length > 0
                  ? this.source.mch_public_list[0].union_bank
                  : "",
              bank_name:
                this.source.mch_public_list.length > 0
                  ? this.source.mch_public_list[0].sub_branch_bank
                  : "",
            };
            this.basicSource.bank = {
              bank_code:
                this.source.mch_public_list.length > 0
                  ? this.source.mch_public_list[0].union_bank
                  : "",
              bank_name:
                this.source.mch_public_list.length > 0
                  ? this.source.mch_public_list[0].sub_branch_bank
                  : "",
            };
          } else {
            this.source.mch_name = this.source.mch_name.split("-")[0];
          }
        })
        .catch((msg) => {
          console.log(`获取草稿件失败。${msg}`);
        });
    },
  },
  mounted() {
    this.getBankClassList();
    this.getDraft();
  },
};
</script>

<style lang="less">
.container-reg-2 {
  .reg-hint {
    @media screen and (max-width: 500px) {
      line-height: 20px;
    }
  }
}
</style>
